import React, { Component } from 'react'

import { connect } from 'react-redux'

import { toggleLoading, toggleSnackBar } from '../../redux/actions'

import './style.css'
import packageJSON from '../../../package.json'



const mapDispatchToProps = dispatch => {
    return {
        toggleLoading: () => dispatch(toggleLoading()),
        toggleSnackBar: msg => dispatch(toggleSnackBar(msg))
    };
};

const mapStateToProps = state => ({
    user: state.user
})

class Home extends Component {
    render() {
        return (
            <div className="items-center">
                <div className="homePage">
                    <footer>v{packageJSON.version}</footer>
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)